"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScannerInput = exports.SCANNER_INPUT = void 0;
/**
 * PDA / handheld scanners (Zebra, Honeywell, Urovo… in "keyboard" mode) send a barcode as keystrokes,
 * all within a few milliseconds and usually followed by Enter. A person types 5–10 times slower.
 * The driver app accepts a scan only when it came that fast, so couriers still cannot type AWBs.
 */
exports.SCANNER_INPUT = {
    /** a longer pause between two keys starts a new code */
    maxGapMs: 60,
    /** average time per key for a scanner (people: 80 ms and more) */
    maxAvgMs: 30,
    minLength: 4,
    /** scanners set to send no Enter: the code ends after this quiet time */
    idleMs: 120,
};
class ScannerInput {
    buf = '';
    first = 0;
    last = 0;
    /** one printable character */
    char(c, at) {
        if (this.buf && at - this.last > exports.SCANNER_INPUT.maxGapMs)
            this.buf = '';
        if (!this.buf)
            this.first = at;
        this.buf += c;
        this.last = at;
    }
    get length() {
        return this.buf.length;
    }
    /** Enter / Tab, or the quiet time ended the code: the code if it came as fast as a scanner, else null. */
    finish() {
        const code = this.buf.trim();
        const avg = this.buf.length > 1 ? (this.last - this.first) / (this.buf.length - 1) : Infinity;
        this.buf = '';
        if (code.length < exports.SCANNER_INPUT.minLength || avg > exports.SCANNER_INPUT.maxAvgMs)
            return null;
        return code;
    }
    clear() {
        this.buf = '';
    }
}
exports.ScannerInput = ScannerInput;
//# sourceMappingURL=scanner-input.js.map